require("!!/app/node_modules/script-loader/addScript.js")(require("!!/app/node_modules/raw-loader/index.js!/app/node_modules/chroma-js/chroma.js"))


//////////////////
// WEBPACK FOOTER
// /app/~/script-loader!/app/~/chroma-js/chroma.js
// module id = ../../../../script-loader/index.js!../../../../chroma-js/chroma.js
// module chunks = 14